
import { fetchConToken } from "../../../helpers/fetch";
import { AppDispatch } from "../../store";

import { endLoadingModulo, ModuloState, setModulo, setModulos } from "./moduloSlice";

export const obtenerModulosCurso = (cid: string) => {

    return async (dispatch: AppDispatch) => {

        try {
            const resp = await fetchConToken(`modulo/obtener/${cid}`);
            const body = await resp.json();

            if (body.ok) {
                const { modulos } = body;
                dispatch(setModulos(modulos))
                dispatch(endLoadingModulo());
                return 
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export const obtenerModuloCurso = (cid: string, modulo: string) => {

    return async (dispatch: AppDispatch) => {

        try {
            const resp = await fetchConToken(`modulo/obtener/${cid}/${modulo}`);
            const body = await resp.json();

            console.log(body)

            if (body.ok) {
                // const { modulos } = body;
                // dispatch(setModulos(modulos))
                // dispatch(endLoadingModulo());
                // return 
            }
        } catch (error) {
            console.log(error)
        }
    }
}

// ADMINISTRADOR
export const crearModulo = (modulo: object) => {

    return async (dispatch: AppDispatch, getState: any) => {

        const { modulos } = getState().modulo;

        try {
            const resp = await fetchConToken(`modulo/crear`, modulo, 'POST');
            const body = await resp.json();

            if (body.ok) {
                const { moduloCreado } = body;
                const modulosActualizado = [...modulos, moduloCreado]
                dispatch(setModulo(moduloCreado))
                dispatch(setModulos(modulosActualizado))
                return 
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export const eliminarModulo = (mid: string) => {

    return async (dispatch: AppDispatch, getState: any) => {

        const { modulos } = getState().modulo;

        try {
            const resp = await fetchConToken(`modulo/eliminar/${mid}`, { mid: mid }, 'DELETE');
            const body = await resp.json();

            if (body.ok) {
                const { moduloEliminado } = body;
                const modulosActualizado = modulos.filter((item: ModuloState) => item.mid !== moduloEliminado.mid);
                dispatch(setModulos(modulosActualizado))
                return 
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export const actualizarModulo = (modulo: ModuloState) => {

    return async (dispatch: AppDispatch, getState: any) => {

        const { mid } = modulo; 

        const { modulos } = getState().modulo;

        try {
            const resp = await fetchConToken(`modulo/actualizar/${mid}`, modulo, 'PUT');
            const body = await resp.json();

            if (body.ok) {
                const { moduloActualizado } = body;

                const modulosActualizado = modulos.map((item: ModuloState) => 
                    item.mid === mid ? moduloActualizado : item
                );

                dispatch(setModulos(modulosActualizado))
                dispatch(endLoadingModulo());
                return 
            }
        } catch (error) {
            console.log(error)
        }
    }
}